export default __webpack_public_path__ + "media/images/icons/download-paper-038941b3d1058a2a3b5c204b5cfc99e4.svg";